import { observable, action, runInAction } from 'mobx'
import { getFuncVal, hasSomeKey, isObj } from '@hlj/hlj-utils'

/**
 * 这个 store 不维护了
 */
export default class {
  $params = {}
  $listApi = () => null
  $filters = {}
  $sorter = {}
  $pageSize = 10
  $initialParams = {}
  //不需要在最后发请求时传递的参数名
  $ignoreParams = []
  $getListApi = () => {
    return this.$listApi
  }
  @observable $list = []
  @observable $loading = false

  @observable
  $pagination = {
    showQuickJumper: true,
    showSizeChanger: true,
    hideOnSinglePage: true,
    showTotal: total => `共 ${total} 条`,
    current: 1,
    total: 0,
    pageSize: this.$pageSize
  }

  $setPageSize = size => {
    this.$pageSize = size
    this.$pagination.pageSize = size
  }

  @observable $selectedRowKeys = []
  @action
  $onSelectChange = keys => {
    this.$selectedRowKeys = keys
  }
  @action
  $paging = ({ current, pageSize }, filters, sorter) => {
    this.$filters = filters
    this.$sorter = sorter
    this.$pagination.current = current
    this.$pagination.pageSize = pageSize
    this.$getList(current)
  }
  /*
   切面，发请求之前和之后的操作$beforeGet,$afterGet
   */
  @action
  $afterGet = (data, page) => {
    const { list, total_count } = data
    this.$list = list || []
    this.$pagination.total = +total_count
    this.$pagination.current = page
    this.$selectedRowKeys = []
    this.$loading = false
    this.$extraOp && this.$extraOp(data, page)
    if (this.$autoPaging) {
      this.$pagination.total = this.$list.length
    }
  }
  @action
  $getList = async (page = this.$pagination.current, params) => {
    this.$loading = true
    if (isObj(page)) {
      params = page
      page = this.$pagination.current
    }
    const resParams = {
      page,
      per_page: this.$pagination.pageSize,
      ...this.$initialParams,
      ...this.$getParams(this.$pagination),
      ...params
    }
    const ignoreParams = getFuncVal(this.$ignoreParams, resParams) || []
    for (let key of ignoreParams) {
      delete resParams[key]
    }

    const { data } = await this.$getListApi()(resParams)
    runInAction(() => {
      this.$afterGet(data, page)
    })
  }

  /**
   * 参数的处理
   */
  $initParams = (name, value) => {
    this.$initialParams[name] = value
    this.$params = Object.assign({}, this.$initialParams, this.$params)
  }

  $clearParams = () => {
    this.$initialParams = {}
    this.$params = {}
  }
  $resetParams = () => {
    this.$params = Object.assign({}, this.$initialParams)
  }
  $search = () => {
    this.$getList(1)
  }

  $getParams() {
    return this.$params
  }

  //当参数改变的时候调用
  $onParamsChange = () => {
    this.$getList(1)
  }

  $setParams = (values, noNeed = []) => {
    if (values) {
      this.$params = Object.assign({}, this.$params, values)
    } else {
      this.$resetParams()
    }
    if (noNeed && !hasSomeKey(values, noNeed)) {
      this.$onParamsChange(values)
    }
  }
}
